import {create} from 'zustand';

type VelaGuestFormStore = {
  hasOptionalFields: boolean;
  setHasOptionalFields: (hasOptionalFields: boolean) => void;
};

export const useVelaGuestFormStore = create<VelaGuestFormStore>(set => ({
  hasOptionalFields: false,
  setHasOptionalFields: hasOptionalFields => set({hasOptionalFields}),
}));
